import { Navigate } from "react-router-dom";

import LoadingPage from "@/components/ui/LoadingPage";

type FeatureFlagRouteProps = {
  isFeatureEnabled: boolean;
  children: JSX.Element;
  fallbackPath?: string;
  isLoading?: boolean;
};

/**
 * Wrapper route component to conditionally render children based on a feature flag.
 * If the feature is enabled, it renders the children; otherwise, it redirects to a fallback route.
 * @param isFeatureEnabled - boolean indicating if the feature is enabled
 * @param children - JSX element to render if the feature is enabled
 * @param fallbackPath - fallbackPath route to redirect to if the feature is not enabled. Defaults to "/".
 * @returns
 */
const FeatureFlagRoute = ({
  isFeatureEnabled,
  children,
  fallbackPath = "/",
  isLoading
}: FeatureFlagRouteProps) => {
  // While loading permissions, render a loading screen to avoid premature redirects
  if (isLoading) return <LoadingPage />;

  // If the feature is not enabled, redirect to fallback route
  return isFeatureEnabled ? children : <Navigate to={fallbackPath} replace />;
};

export default FeatureFlagRoute;
